export const FLYING_DOCUMENTATION_BASE_URL: string = 'https://documentation.flyingresearch.net/';

/** Anchors from the deployed guide; keep these aligned with its chapters. */
export const FLYING_DOCUMENTATION_ROUTES: Readonly<Record<string, string>> = {
	'/research/research/best-sellers': 'best-sellers',
	'/research/research/seller-trends': 'seller-trends',
	'/research/research/archive': 'archive',
	'/research/research/deleted-designs': 'deleted',
	'/research/research/real-time-research': 'real-time-research',
	'/research/research/niche-analysis': 'niche-analysis',
	'/research/research/get-inspired-pod': 'get-inspired-pod',
	'/research/research/hobby-list': 'workflow-find-niches',
	'/research/research/detail': 'metrics',
	'/research/research/brands': 'official-brands',
	'/research/research/favorites': 'design-favorites',
	'/research/research/pod-report': 'pod-report',
	'/research/ai/niche-finder': 'aurora',
	'/research/ai/prompt-search': 'reveal',
	'/research/ai/quotes-and-puns': 'mumble',
	'/research/ai/ai-design-editor': 'ai-design-editor',
	'/research/keyword/kw-search': 'kw-search',
	'/research/keyword/kw-hunter': 'kw-hunter',
	'/research/keyword/product-explorer': 'product-explorer',
	'/research/keyword/kw-suggestions': 'kw-suggestions',
	'/research/keyword/kw-workbench': 'kw-workbench',
	'/research/keyword/tag-generator': 'tag-generator',
	'/research/keyword/kw-lists': 'kw-lists',
	'/research/keyword/kw-competition': 'keyword-reference',
	'/research/advertisement/positioning': 'rank-positioning',
	'/research/advertisement/ad-suggestions': 'ad-suggestions',
	'/research/advertisement/ad-lists': 'ad-lists',
	'/research/events/social-media-holidays': 'social-media-holidays',
	'/research/events/event-calendar': 'calendar',
	'/research/trademark/tm-search': 'tm-search',
	'/research/trademark/tm-registrations': 'tm-registrations',
	'/research/trademark/tm-watchlist': 'tm-watchlist',
	'/upload/pod/statistics': 'upload-statistics',
	'/upload/pod/design-management': 'upload-designs',
	'/upload/pod/design-management/import': 'upload-designs--add-designs-import-files',
	'/upload/pod/design-management/excel-import': 'upload-designs--add-designs-import-files',
	'/upload/pod/edit': 'upload-edit',
	'/upload/pod/ai-templates': 'upload-ai-templates',
	'/upload/pod/ai-design-editor': 'upload-ai-design-editor',
	'/upload/pod/tm-report': 'upload-tm-report',
	'/upload/pod/tm-whitelist': 'upload-tm-whitelist',
	'/upload/pod/tm-blacklist': 'upload-tm-blacklist',
	'/upload/upload/setup-pod-uploader': 'upload-setup-pod',
	'/upload/upload/setup-kdp-uploader': 'upload-setup-kdp',
	'/upload/upload/accounts-templates': 'upload-setup-pod--steps-2-and-3-usage-and-configuration',
	'/upload/upload/template-groups': 'upload-setup-pod--steps-2-and-3-usage-and-configuration',
	'/upload/upload/upload-schedule': 'workflow-batch-upload',
	'/upload/kdp/edit': 'upload-setup-kdp--step-2-kdp-overview-and-usage',
	'/settings/research/email-notifications': 'tm-watchlist--notifications-and-review-routine',
	'/settings/subscriptions': 'overview',
	'/settings': 'help--troubleshooting',
	'/support': 'help',
	'/support/report': 'help--troubleshooting',
	'/tutorials/tutorial-research-welcome': 'overview',
	'/tutorials/tutorial-research': 'overview',
	'/tutorials/tutorial-keywords': 'keyword-reference',
	'/tutorials/tutorial-trademarks': 'workflow-trademark-check',
	'/tutorials/tutorial-design-management': 'upload-designs',
	'/tutorials/tutorial-pod-upload': 'upload-setup-pod',
	'/tutorials/tutorial-kdp-upload': 'upload-setup-kdp',
	'/tutorials': 'overview'
};
